import {peachpayUpdateCurrencyCookie} from '../../../frontend/@shared/ts/currency';
import {__} from '@wordpress/i18n';

export default function CurrencyFallback(props: {name: string; currency: string | null}) {
	function changeCurrency() {
		if (!props.currency) {
			return;
		}

		peachpayUpdateCurrencyCookie(props.currency);
		window.location.reload();
	}

	return props.currency ? (
		<div style={{display: 'flex', flexDirection: 'column'}}>
			<p style={{textAlign: 'justify', margin: '0.5rem 0 0', fontSize: 'smaller'}}>
				{props.name} {__('does not support the currency you currently have chosen.', 'peachpay-for-woocommerce')} <b>{__('Update to', 'peachpay-for-woocommerce')} {props.currency}</b> {__('below to use this payment method.', 'peachpay-for-woocommerce')}
			</p>
			<button type='button' className='button currency-fallback-button' style={{fontSize: 'smaller', marginBottom: '16px'}}
				onClick={changeCurrency}
			>{__('Update to', 'peachpay-for-woocommerce')} {props.currency}</button>
		</div>
	) : null;
}
